import { jsx as _jsx } from "preact/jsx-runtime";
import styles from './FandomAvatar.module.scss';
export const FandomAvatar = ({ interest }) => {
    const avatar = (_jsx("div", Object.assign({ className: styles.avatar, style: { backgroundColor: interest.color } }, { children: _jsx("img", { className: styles.image, src: `${interest.image.url}/thumbnail/width/36/height/36`, alt: interest.name }, void 0) }), void 0));
    return avatar;
};
